import PlannedGridView from "@/components/PlannedGridView";

export default function PlannedAbsencesView() {
  return (
    <PlannedGridView
      endpointBase="/reports/planned-absences-grid"
      pageEyebrow="Planned Absences"
      defaultScopeLabel="Planned Absences"
      filenameFallback="rrdc-planned-absences"
      cellPalette="red"
      errorLabel="planned absences"
    />
  );
}
